import clsx from "clsx";
import { ChevronLeft } from "lucide-react";
import { Icon } from "../Icon/Icon.js";
import styles from "./BackButton.module.scss";

export interface BackButtonProps {
  onClick?: () => void;
  /** Accessible name — the destination, e.g. "Back to shows" (default "Back"). Icon-only, so this rides
   *  `aria-label`. */
  label?: string;
  className?: string;
}

/**
 * The mobile back affordance — a bare, muted left-chevron (the "VIP" look). One primitive for every mobile
 * screen header + full-screen takeover, so they stop drifting: before this there were four hand-rolled back
 * buttons (a bordered pill, a hover-fill circle, an ArrowLeft and a ChevronLeft). Icon-only; the destination
 * rides `aria-label` via `label`.
 *
 * (The band/artist PROFILE modal keeps its own scrim-filled floating back — it sits OVER a hero photo and
 * needs the contrast a bare glyph can't give, the same reason `IconButton` has an `invert` tone.)
 */
export function BackButton({ onClick, label = "Back", className }: BackButtonProps) {
  return (
    <button type="button" className={clsx(styles.back, className)} aria-label={label} onClick={onClick}>
      <Icon icon={ChevronLeft} size={20} />
    </button>
  );
}
